import BaseParser from './BaseParser';
import _get from 'lodash/get';
import { valueUnitToString } from './util';

class Amount extends BaseParser {
  // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
  getDisplayValue(fhirProperty: fhir.Money) {
    if (!fhirProperty) return null;

    const value = _get<fhir.Money, 'value', number>(
      fhirProperty,
      'value',
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      null,
    );
    const unit = _get<fhir.Quantity, 'code', string>(
      fhirProperty,
      'code',
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      null,
    );

    return valueUnitToString(value, unit);
  }

  // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
  getSortValue(fhirProperty: fhir.Money) {
    if (!fhirProperty) return null;

    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
    return _get<fhir.Quantity, 'value', number>(fhirProperty, 'value', null);
  }
}

export default Amount;
